export default __webpack_public_path__ + "static/media/rendertotexture.388b23b1.vert";